import { deleteDoc, doc } from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { CollectionOptions, getCollection } from './helpers';

export const deleteSmartList = async (
  _userId: ID,
  smartListId: ID,
): Promise<void> => {
  const collection = getCollection(CollectionOptions.SmartLists);
  const ref = doc(collection, smartListId);

  deleteDoc(ref);
};
